"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unMinifyType = exports.minifyType = void 0;
function minifyType(params) {
    const type = params.value;
    if (type === 'ATOMIC') {
        return 'A';
    }
    if (type === 'COMPLEX') {
        return 'C';
    }
}
exports.minifyType = minifyType;
function unMinifyType(params) {
    const minifiedType = params.value;
    if (minifiedType === 'A') {
        return 'ATOMIC';
    }
    if (minifiedType === 'C') {
        return 'COMPLEX';
    }
}
exports.unMinifyType = unMinifyType;
//# sourceMappingURL=typeMinifier.js.map